import { has, get } from 'lodash';

const getPropTokenVanilla = (theme, componentKey, key, prop, propValue = 'default', appearance = 'default') => {
    const tokenPaths = [
        `${componentKey}.appearance.${appearance}.${prop}.${propValue}.${key}`,
        ...propValue !== 'default' ? [`${componentKey}.appearance.${appearance}.${prop}.default.${key}`] : [],
        ...appearance !== 'default' ? [`${componentKey}.appearance.default.${prop}.${propValue}.${key}`] : [],
        ...appearance !== 'default' && propValue !== 'default' ?
            [`${componentKey}.appearance.default.${prop}.default.${key}`] : [],
    ];
    for (const tokenPath of tokenPaths) {
        if (has(theme.components, tokenPath)) {
            return get(theme.components, tokenPath);
        }
    }
    return undefined;
};
const getPropToken = (componentKey, key, prop, propValue = 'default', appearance = 'default') => (props) => {
    const appearanceContextValue = appearance === 'default' && props['appearance'] ? props['appearance'] : appearance;
    const propContextValue = propValue === 'default' && props[prop] ? props[prop] : propValue;
    return getPropTokenVanilla(props.theme, componentKey, key, prop, propContextValue, appearanceContextValue);
};

export { getPropToken, getPropTokenVanilla };
//# sourceMappingURL=getPropToken.js.map
